import React from "react";
import "./index.less";
import { Button, Image } from "antd";
import { WifiIcon } from "../../SvgIconCom/ChatBottomToolIcon";
import noiseSVG from "../icons/noise.svg";
import hangupSVG from "../icons/hangup.svg";
import { useTranslate } from "@obsbot/remo-i18n";
import { useParams } from "react-router-dom";
import { RouteNameType, usePushHistory } from "@obsbot/remo-pages/src/utils/routes";
import { useChannelStore, useGlobalStore } from "@obsbot/remo-stores";
export interface ConnectProps {
    connectStatus?: "connecting" | "no_connected" | "connected" | "disconnecting";
    delay?: number; // 延迟时间，单位为毫秒，默认为0，即不延迟
    leaveRoom: () => Promise<void>;
    onHandleLeave?: () => void; // 点击设置按钮的回调函数
}
export const ConnectStatus: React.FC<ConnectProps> = ({
    connectStatus = "no_connected",
    delay = 0,
    leaveRoom,
    onHandleLeave,
}) => {
    const params = useParams();
    const t = useTranslate();
    const pushHistory = usePushHistory();
    const { activeChannel } = useChannelStore();
    const { needShowGuide, updateNeedShowGuide } = useGlobalStore();
    // 降噪
    const noiseReduce = (): void => {
        console.log("Noise Reduce");
    };
    // 挂断
    const hangUpCalling = async (): Promise<void> => {
        if (needShowGuide.channel || needShowGuide.specialEffect) {
            updateNeedShowGuide({
                channel: false,
                specialEffect: false,
            });
        }
        await leaveRoom();
        onHandleLeave && onHandleLeave();
    };
    // 处理点击已连接回到频道
    const backToChannel = (): void => {
        if (params && params.roomUUID) {
            return;
        }
        if (!activeChannel) {
            return;
        }
        pushHistory(RouteNameType.ChannelRoomPage, {
            roomUUID: activeChannel.channelUuid,
        });
    };

    return (
        <div className="tool-status">
            <div className="connect-status" onClick={backToChannel}>
                {connectStatus === "connected" && <WifiIcon delay={delay} />}
                <span
                    className={`status-text status-${connectStatus} ${delay < 100 ? "strong" : delay <= 200 ? "middle" : "weak"}`}
                >
                    {t("chat." + connectStatus)}
                </span>
            </div>
            {/* 只有连接中和已连接才显示降噪和挂断 */}
            {connectStatus === "connected" || connectStatus === "connecting" ? (
                <>
                    <Button
                        icon={<Image preview={false} src={noiseSVG} />}
                        style={{ marginLeft: "auto" }}
                        type="text"
                        onClick={noiseReduce}
                    ></Button>
                    <Button
                        icon={<Image preview={false} src={hangupSVG} />}
                        type="text"
                        onClick={hangUpCalling}
                    ></Button>
                </>
            ) : null}
        </div>
    );
};
